import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import ResourceAdd from '@/components/System/resource/resourceadd';
import delDialog from '@/components/System/DelDialog';
import NoData from '@/components/NoData/NoData';
import remoteImg from '@/components/common/remoteImg';
import { valsubstr32addbr } from '@/utils/index';
import { getSystemInnerList } from '@/api/message';
import _expand from 'element-ui/packages/table/src/store/expand';
export default {
  computed: {
    expand: function expand() {
      return _expand;
    }
  },
  components: {
    SearchForm: SearchForm,
    ResourceAdd: ResourceAdd,
    delDialog: delDialog,
    NoData: NoData,
    remoteImg: remoteImg
  },
  data: function data() {
    return {
      multipleSelection: null,
      selectresouse: [],
      delChecked: false,
      // 删除权限
      searchFormData: [{
        title: '系统名称',
        key: 'sysName',
        placeholder: '请选择系统名称',
        type: 'selectsystem',
        selectData: [],
        selectedArr: [],
        multiple: false
      }, {
        title: '资源名称',
        key: 'role',
        placeholder: '请输入资源名称',
        type: 'input',
        value: null
      }, {
        title: '资源编号',
        key: 'role',
        placeholder: '请输入资源编号',
        type: 'input',
        value: null
      }],
      isportresource: true,
      menulist: [],
      portlist: [],
      activeName: 'INTERFACE',
      btnType: 'add,search,reset',
      showPowerMaintain: false,
      // 角色与权限关联
      showPowerPower: false,
      // 查看权限
      ifAddEdit: false,
      // true 编辑  false 新增
      showRoleEdit: false,
      // 显示角色编辑弹出框
      selectpermissionId: 0,
      selectsystem: null,
      editResource: null,
      isfiltrate: false,
      isaddchild: false,
      iseditfatherresource: false,
      filtratedata: {
        pageNum: 1,
        pageSize: 10,
        resourceId: '',
        resourceName: '',
        systemId: '',
        resourceType: 'INTERFACE'
      },
      formRole: {
        sysName: [],
        roleNum: null,
        roleName: [],
        type: null,
        desc: null,
        status: null
      },
      specificUserForm: {
        roleName: [],
        roleNum: null,
        userName: null,
        type: [],
        roleDep: [],
        tel: null
      },
      totalrecord: 0,
      totalpages: 0,
      ifShowDelDialog: false,
      loadingResource: false,
      isIndeterminate: false,
      tableheight: 520,
      faceNum: 1,
      resourceNum: 1,
      paginationShow: 'INTERFACE',
      faceTotal: 0,
      resourceTotal: 0,
      isresource: '',
      mobileTotal: 0,
      mobileNum: 0,
      expandList: new Set(),
      expandListMap: new Map() // 用于value保存展开节点的{row,treeNode,resolve}，key为节点ID
    };
  },
  created: function created() {
    this.getresource();
    this.getsystemlist();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 340;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 340;
      };
    });
  },
  methods: {
    handleTableCurrentChange: function handleTableCurrentChange() {},
    expandChange: function expandChange(row, expanded) {
      if (expanded) {
        this.expandList.add(row.id);
      } else {
        this.expandList.delete(row.id);
      }
    },
    sortResource: function sortResource(scope, direction) {
      var _this = this;
      console.log(scope, direction, 'ksdjfksdjfkj');
      var row = scope.row;
      scope._self.$refs["resource-".concat(row.id)].doClose();
      this.$API.postRequest({
        url: '/platform/resource/sortResource',
        data: {
          resourceId: row.resourceId,
          parentResourceId: row.parentResourceId,
          direction: direction
        }
      }).then(function () {
        _this.reloadTree(row.parentId);
      });
    },
    // 重新加载子节点资源
    reloadTree: function reloadTree(parentId) {
      // 如果没有父节点id则直接刷新整体数据
      if (!parentId) {
        this.getresource();
        return;
      }
      var _this$expandListMap$g = this.expandListMap.get(parentId),
        row = _this$expandListMap$g.row,
        treeNode = _this$expandListMap$g.treeNode,
        resolve = _this$expandListMap$g.resolve;
      this.load(row, treeNode, resolve);
    },
    load: function load(row, treeNode, resolve) {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/resource/menuList',
        data: _objectSpread(_objectSpread({}, this.filtratedata), {}, {
          parentResourceId: row.resourceId,
          resourceLevel: row.resourceLevel
        })
      }).then(function (res) {
        if (res.code === '0000000000') {
          var _res$result;
          // 将获取到的节点数据添加到expandListMap变量中
          _this2.expandListMap.set(row.id, {
            row: row,
            treeNode: treeNode,
            resolve: resolve
          });
          (_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.records.map(function (item) {
            return item.parentId = row.id;
          });
          resolve(res.result.records);
        }
      });
    },
    getresource: function getresource() {
      var _this3 = this;
      this.loadingResource = true;
      this.paginationShow = this.filtratedata.resourceType;
      if (this.filtratedata.resourceType === 'INTERFACE') {
        this.filtratedata.pageNum = this.faceNum;
      } else if (this.filtratedata.resourceType === 'RESOURCE') {
        this.filtratedata.pageNum = this.resourceNum;
        this.filtratedata.parentResourceId = 0;
      } else if (this.filtratedata.resourceType === 'MOBILE') {
        this.filtratedata.pageNum = this.mobileNum;
        this.filtratedata.parentResourceId = 0;
      }
      if (this.filtratedata.resourceId || this.filtratedata.resourceName || this.filtratedata.systemId && this.filtratedata.systemId.length > 0) {
        this.filtratedata.parentResourceId = '';
      }
      this.$API.getRequest({
        url: '/platform/resource/menuList',
        data: this.filtratedata
      }).then(function (res) {
        _this3.loadingResource = false;
        if (res.code === '0000000000') {
          _this3.menulist = res.result.records;
          if (_this3.filtratedata.resourceType === 'INTERFACE') {
            _this3.faceTotal = res.result.total;
          } else if (_this3.filtratedata.resourceType === 'RESOURCE') {
            _this3.resourceTotal = res.result.total;
          } else {
            _this3.mobileTotal = res.result.total;
          }
          _this3.$forceUpdate();
          _this3.grtmenulistcount(_this3.menulist);
        }
      });
    },
    grtmenulistcount: function grtmenulistcount(list) {
      var _this4 = this;
      // eslint-disable-next-line array-callback-return
      list.filter(function (ele) {
        if (ele.children && ele.children.length > 0) {
          _this4.grtmenulistcount(ele.children);
        }
      });
    },
    getsystemlist: function getsystemlist() {
      var _this5 = this;
      getSystemInnerList().then(function (res) {
        var code = res.code;
        if (code === '0000000000') {
          _this5.$nextTick(function () {
            _this5.searchFormData[0].selectData = res.result.records;
          });
          //   this.selectData = result.records;
        }
      });
    },
    handleSelectionChangeport: function handleSelectionChangeport(val) {
      this.multipleSelection = val;
    },
    handleSelectionChangemenu: function handleSelectionChangemenu(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.filtratedata.pageNum = val;
      if (this.filtratedata.resourceType === 'RESOURCE') {
        this.resourceNum = val;
      } else if (this.filtratedata.resourceType === 'INTERFACE') {
        this.faceNum = val;
      } else if (this.filtratedata.resourceType === 'MOBILE') {
        this.mobileNum = val;
      }
      this.getresource();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.filtratedata.pageSize = val;
      this.getresource();
    },
    // 查询
    searchForm: function searchForm(obj) {
      this.isfiltrate = true;
      this.filtratedata.systemId = obj[0].selectedArr;
      this.filtratedata.resourceName = obj[1].value;
      this.filtratedata.resourceId = obj[2].value;
      // this.filtratedata.pageNum = 1;
      if (this.filtratedata.resourceType === 'INTERFACE') {
        this.faceNum = 1;
        this.paginationShow = true;
      } else {
        this.resourceNum = 1;
        this.paginationShow = false;
      }
      this.getresource();
    },
    resetForm: function resetForm(obj) {
      this.searchFormData[0].selectedArr = [];
      this.searchFormData[1].value = '';
      this.searchFormData[2].value = '';
      this.filtratedata.systemId = obj[0].selectedArr;
      this.filtratedata.resourceName = obj[1].value;
      this.filtratedata.resourceId = obj[2].value;
      if (this.filtratedata.resourceType === 'INTERFACE') {
        this.faceNum = 1;
        this.paginationShow = true;
      } else {
        this.resourceNum = 1;
        this.paginationShow = false;
      }
      this.getresource();
    },
    addTable: function addTable() {
      this.isaddchild = false;
      this.iseditfatherresource = false;
      this.selectsystem = null;
      // this.editRoleDialog(obj, false)
      this.ifAddEdit = false;
      this.powerAddClose(true);
    },
    editRoleDialog: function editRoleDialog(item, bool, ismenu) {
      this.ifAddEdit = bool;
      if (item.row.parentResourceId === '0' && this.activeName === 'RESOURCE') {
        this.iseditfatherresource = true;
      } else {
        this.iseditfatherresource = false;
      }
      if (ismenu) {
        this.$refs["resource-".concat(item.row.id)] && this.$refs["resource-".concat(item.row.id)].doClose();
      } else {
        this.$refs["resource-".concat(item.row.id)] && this.$refs["interface-".concat(item.row.id)].doClose();
      }
      // this.$refs[`interface-` + item.row.id].doClose()
      // this.$refs[`resource-` + item.row.id].doClose()
      item.row.resourceType = this.activeName;
      this.selectsystem = JSON.parse(JSON.stringify(item.row));
      this.editResource = item.row;
      this.powerAddClose(true);
    },
    addresouseFn: function addresouseFn(item, bool) {
      this.ifAddEdit = bool;
      this.isaddchild = true;
      this.iseditfatherresource = false;
      this.$refs["resource-".concat(item.row.id)].doClose();
      this.selectsystem = JSON.parse(JSON.stringify(item.row));
      this.editResource = item.row;
      this.powerAddClose(true);
    },
    powerAddClose: function powerAddClose(bool) {
      this.showRoleEdit = bool;
    },
    ResourceAddSubmit: function ResourceAddSubmit(obj) {
      this.powerAddClose(false);
      if (obj.bool) {
        // 点击提交
        obj.formData.icon = obj.formData.iconPath;
        obj.formData.functionIcon = obj.formData.functionIconPath;
        if (this.ifAddEdit) {
          obj.formData.id = this.editResource.id;
          this.editresouse(obj.formData);
        } else {
          this.addresouse(obj.formData);
        }
      }
    },
    addresouse: function addresouse(obj) {
      var _this6 = this;
      if (obj.resourceType === 'RESOURCE' || obj.resourceType === 'MOBILE') {
        if (this.isaddchild) {
          obj.parentResourceId = this.editResource.resourceId;
        }
        if (obj.resourceType === 'MOBILE') {
          obj.directoryResource = 'FALSE';
        }
        this.$API.postRequest({
          url: '/platform/resource/menu/',
          data: obj
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this6.$message({
              message: '添加资源成功',
              type: 'success'
            });
            _this6.reloadTree(obj.parentId);
          }
        });
      } else {
        this.$API.postRequest({
          url: '/platform/resource/interface/',
          data: obj
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this6.$message({
              message: '添加资源成功',
              type: 'success'
            });
            _this6.getresource();
          }
        });
      }
    },
    editresouse: function editresouse(obj) {
      var _this7 = this;
      if (obj.resourceType === 'RESOURCE' || obj.resourceType === 'MOBILE') {
        this.$API.putRequest({
          url: '/platform/resource/menu/',
          data: obj
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.$message({
              message: '修改资源成功',
              type: 'success'
            });
            _this7.reloadTree(obj.parentId);
          }
        });
      } else {
        this.$API.putRequest({
          url: '/platform/resource/interface/',
          data: obj
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.$message({
              message: '修改资源成功',
              type: 'success'
            });
            _this7.getresource();
          }
        });
      }
    },
    delresourcefn: function delresourcefn(obj) {
      var _this8 = this;
      this.$API.delRequest({
        url: '/platform/resource/',
        data: this.selectresouse
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this8.$message({
            message: '删除资源成功',
            type: 'success'
          });
          _this8.getNum();
          _this8.reloadTree(obj.parentId);
        }
      });
    },
    getNum: function getNum() {
      if (this.activeName === 'INTERFACE') {
        if (this.calculation(this.faceNum, this.faceTotal)) {
          this.faceNum > 1 ? this.faceNum-- : this.faceNum = 1;
        }
      } else if (this.activeName === 'RESOURCE') {
        if (this.calculation(this.resourceNum, this.resourceTotal)) {
          this.resourceNum > 1 ? this.resourceNum-- : this.resourceNum = 1;
        }
      }
    },
    calculation: function calculation(Num, Total) {
      // 计算下标num
      return Num === Math.ceil(Total / this.filtratedata.pageSize) && (Total % this.filtratedata.pageSize === this.selectresouse.length || Total % this.filtratedata.pageSize === 0);
    },
    // 是否删除单个接口资源
    confirmdelINTERFACE: function confirmdelINTERFACE(obj, bool) {
      if (bool) {
        this.selectresouse = [obj.row.resourceId];
        this.$refs["interface-".concat(obj.row.id)].doClose();
        this.delresourcefn(obj.row);
      }
    },
    // 是否删除单个菜单资源
    confirmdelRESOURCE: function confirmdelRESOURCE(obj, bool) {
      if (bool) {
        this.selectresouse = [obj.row.resourceId];
        this.$refs["resource-".concat(obj.row.id)].doClose();
        this.delresourcefn(obj.row);
      }
    },
    // 删除确认弹框
    showdeldialog: function showdeldialog() {
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.ifShowDelDialog = true;
      } else {
        this.$message({
          message: '请选择删除项',
          type: 'warning'
        });
      }
    },
    delresource: function delresource() {
      var _this9 = this;
      this.ifShowDelDialog = false;
      this.selectresouse = [];
      // eslint-disable-next-line array-callback-return
      this.multipleSelection.filter(function (item) {
        _this9.selectresouse.push(item.resourceId);
      });
      this.delresourcefn();
    },
    handleClick: function handleClick(val) {
      this.delChecked = false;
      this.filtratedata.resourceType = val.name;
      this.isresource = val.name;
      this.getresource();
    },
    // selectAll(checked){
    //   if(checked){
    //     if(this.activeName == "INTERFACE"){
    //       this.menulist.forEach((ele)=>{
    //        this.$refs.multipleInterfaceTable.toggleRowSelection(ele,true)
    //       })
    //     }else{
    //       this.selectallresouce(this.menulist);
    //     }
    //   }else{
    //     this.$refs.multipleInterfaceTable.clearSelection()
    //     this.$refs.multipleresourceTable.clearSelection()
    //   }
    //   this.isIndeterminate = false;
    // },
    // selectallresouce(resoucelist){
    //   resoucelist.filter((ele)=>{
    //     this.$refs.multipleresourceTable.toggleRowSelection(ele,true);
    //     if(ele.children.length > 0){
    //       this.selectallresouce(ele.children);
    //     }
    //   })
    // },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};